export const isAbortedRequestError = (
  error:
    | {
        message: string;
      }
    | null
    | undefined
) => {
  return (
    (error?.message.includes('The operation was aborted') || // Chromium & Safari
      error?.message.includes('The user aborted a request') || // Firefox
      error?.message.includes('signal is aborted without reason')) ??
    false
  );
};
